export const DOMAIN_PROCUREMENT = "PROCUREMENT";
